import React from 'react'
import * as actions from './actions'
import { AdminDeposit } from 'src/core/models'

const AdminDepositActionsColumn: React.FC<{ deposit: AdminDeposit }> = ({ deposit }) => {
  return <div className='centered'>
    {/* Details */}
    <actions.AdminDepositDetails deposit={deposit} />
    {/* Validate Deposit */}
    <actions.AdminDepositValidateButton deposit={deposit} />
    {/* Reject Deposit */}
    <actions.AdminDepositCancelButton deposit={deposit} />
  </div>
}

export default AdminDepositActionsColumn
